import React from 'react';
import { useRef, useEffect } from 'react';

import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import GTMHelper from '../../../Helpers/gtmHelper';

import { Tooltip } from '../../1_Atoms/Tooltip/Tooltip';

export const CollapseList = ({CollapseClasses, ColCarText1, ColBoxText, TooltipName, TooltipText, ColClassPrice, ColPrices, id, ...props }) => {

	const gtmHelper = new GTMHelper();
    const [toggle, setToggle] = React.useState(false);
    const collapseRef = useRef();
    const [didInit, setInit] = React.useState(false);

    useEffect(() =>{
        const collapse = collapseRef.current; 
        
        if(typeof window.mzAnimator === 'object' && !didInit && toggle){
            window.mzAnimator.animateHeight(collapse, 'CollapseList' + id, 'init')
            setInit(true);
            toggleCollapse(collapse);
        }else{
            toggleCollapse(collapse);
        }
   },[toggle, didInit]);

   useEffect(() =>{
       // Force a rerender to fix the height since the content has chanegd
       setInit(false);
   },[ColBoxText]);

   function toggleCollapse(collapse){
        if(toggle){
            window.mzAnimator.animateHeight(collapse, 'CollapseList' + id, true)
        }else if(toggle === false){
            window.mzAnimator.animateHeight(collapse, 'CollapseList' + id, false)
        }
   }

    return (
        <div className="mz-collapse mz-collapse--list">
            <button
                onClick={() =>{
					setToggle(!toggle);
					gtmHelper.setGTM({'action':'Collapse', 'type': 'Cash ' + ColCarText1, 'value': toggle}, true , false);
				}}
                className={CollapseClasses}
            >
                <div className="mz-collapse__cartext-container">
                    <div className="mz-collapse__text">
                        {ReactHtmlParser(ColCarText1)}
                        {TooltipName !=='' && TooltipName !== undefined ?<Tooltip TooltipName={TooltipName}/>:<Tooltip TooltipText={TooltipText}/>}
                    </div>
                </div>
                <i className={ toggle ? "mz-svg mz-svg-chevron_small open  mz-svg--grey paragraph" : "mz-svg mz-svg-chevron_small  mz-svg--grey"} style={{'fontSize': '1rem'}}></i>
                <span className={ColClassPrice}>{ColPrices}</span>
            </button>
            <div className="mz-collapse__box visible" ref={collapseRef}>{ ReactHtmlParser (ColBoxText) }</div>
        </div>
    )
}

CollapseList.propTypes = {
    CollapseClasses: PropTypes.string,
    ColCarText1: PropTypes.string,
    ColBoxText: PropTypes.string,
    TooltipName: PropTypes.string,
    ColPrices: PropTypes.string,
    ColClassPrice: PropTypes.string,
}

CollapseList.defaultProps = {
    CollapseClasses: 'mz-collapse__button',
    ColCarText1: 'Term: 60 months @2.95%',
    ColPrices: '$XX,XXX',
    ColClassPrice: 'mz-collapse__price',
    ColBoxText: 'Pellentesque in ipsum id orci porta dapibus. Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem. Nulla porttitor accumsan tincidunt. Cras ultricies ligula sed magna dictum porta. Nulla quis lorem ut libero malesuada feugiat. Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem. Quisque velit nisi, pretium ut lacinia in, elementum id enim. Nulla porttitor accumsan tincidunt. Sed porttitor lectus nibh. Proin eget tortor risus.',
}

export default CollapseList;